import { configureStore } from '@reduxjs/toolkit'
import agencyReducer from '../../entities/agency/model/agencySlice'
import agentReducer from '../../entities/agent/model/agentSlice'

export const store = configureStore({
  reducer: {
    agency: agencyReducer,
    agent: agentReducer,
  },
})
